import { useLlmTokenUsageService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';

export function useLlmDebugFlag(): boolean {
  const usageService = useLlmTokenUsageService();
  const { data: usageData } = useDataLoaderNew(usageService.getUsage);
  return usageData?.isLlmDebugEnabled ?? false;
}
